import { render, staticRenderFns } from "./AHWaveform.vue?vue&type=template&id=f61d95b6&"
import script from "./AHWaveform.vue?vue&type=script&lang=ts&"
export * from "./AHWaveform.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports